import type { DocNode } from '@atlaskit/adf-schema';

import { buildAdfDocForRichText } from './buildAdfDocForRichText';

/**
 * Returns doc.content for editor insert/replace, not a top-level ADF doc.
 */
export const buildEditorInsertAdfFragment = (
	content: string | DocNode,
	markdownData?: Record<string, string | undefined>,
): NonNullable<DocNode['content']> | null => {
	const doc = buildAdfDocForRichText(content, markdownData);
	return doc?.content ?? null;
};
